<template>
  <div class="evaluationdetail">
    <div style="padding: 20px 20px 0 20px;background-color: white" class="tableWrap">
      <span>姓名</span>
      <div class="name">
        <el-input placeholder="请输入姓名..." v-model="paramForm.name"></el-input>
      </div>
      <span>身份证</span>
      <div class="card">
        <el-form ref="paramForm" :model="paramForm" :rules="rules">
          <el-form-item prop="idCard">
            <el-input v-model="paramForm.idCard" placeholder="请输入身份证号..."></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span>促销员ID</span>
      <div class="name">
        <el-input placeholder="请输入促销员ID..." v-model="paramForm.empPk"></el-input>
      </div>
      <el-button class="search-btn" @click="submitForm()">筛选</el-button>

      <i style="margin-top: 20px;display: block; font-style:normal" class="table">
        <el-table size="small" border style="width: 100%" :data="tableData" v-loading="loading">
          <el-table-column type="index" label="编号" width="60" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" width="260" align="center"></el-table-column>
          <el-table-column prop="empPk" label="促销员ID" width="260" align="center"></el-table-column>
          <el-table-column prop="idcard" label="身份证" align="center"></el-table-column>
          <el-table-column prop="score" label="积分" width="200" align="center"></el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="pointer mingxi" :disabled="auths.indexOf(2) < 0"
                         @click="showDetails(scope.row)">查看{{page}}明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination" :current-page="pageNo"
                       @size-change="handleSizeChange" :page-sizes="[10, 20, 30, 40]"
                       @current-change="handleCurrentChange" :page-size="pageSize"
                       :total="total" layout="sizes,total,prev, pager, next, jumper">
        </el-pagination>
      </i>
    </div>

    <div class="popUp">
      <el-dialog :title="dialogData.name+' '+page+'明细'" :visible.sync="dialogTableVisible">
        <div class="chooseHeader" v-if="scoreType != 1">
          <div class="pointer" :class="{'isChoose' : dialogTab == 1}" @click="dialogTab = 1">项目分</div>
          <div class="pointer" :class="{'isChoose' : dialogTab == 2}" @click="dialogTab = 2">交互分</div>
        </div>
        <i style="display: block; font-style:normal;padding: 20px 20px 0 20px;background-color: #f4f4f4"
           class="table" v-if="dialogTab == 1">
          <div class="search popUp">
            <span>时间段</span>
            <el-date-picker range-separator="至"
                            v-model="dialogData.tab1.time" type="daterange"
                            start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>

            <el-button class="search-btn" @click="submitForm2">筛选</el-button>
          </div>
          <el-table size="small" border style="width: 100%" :data="dialogData.tab1.data" v-loading="load">
            <el-table-column type="index" label="编号" width="60" align="center"></el-table-column>
            <!--非积分页的cols，下面是积分页专用cols-->
            <el-table-column prop="projectName" label="项目" width="300" align="center" v-if="scoreType != 1"></el-table-column>
            <el-table-column label="岗位类型" align="center" v-if="scoreType != 1">
              <template slot-scope="scope">
                <div v-if="scope.row.signId == 1">长促</div>
                <div v-if="scope.row.signId == 2">短促</div>
                <div v-if="scope.row.signId == 0">不限</div>
              </template>
            </el-table-column>
            <el-table-column prop="projectStartTime" label="项目开始时间" width="100" v-if="scoreType != 1"
                             align="center" :formatter="formatTime"></el-table-column>
            <el-table-column prop="projectEndTime" label="项目结束时间" width="100" v-if="scoreType != 1"
                             align="center" :formatter="formatTime"></el-table-column>
            <el-table-column :label="page+'得分'" align="center" v-if="scoreType != 1" width="150">
              <template slot-scope="scope">
                <div class="popover">{{returnScore(scope.row.itemScore)}}
                  {{hehe(scope.row)}}
                  <el-popover visible-arrow='false' ref='popover1' trigger="hover"
                              placement="left" width="210" popper-class="popText">
                    <div class="hoverPop">
                      <div v-for="(item,key) in scope.row.itemScore" :key="key" class="hoverWrap">
                        <div class="hoverPopKey">{{key}}</div>
                        <div class="hoverPopValue" v-if="item >= 0">+ {{item}}</div>
                        <div class="hoverPopValue" v-if="item < 0"> - {{Math.abs(item)}}</div>
                      </div>
                    </div>
                    <el-button slot="reference">查看得分详情</el-button>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <!--积分页专用cols-->
            <el-table-column prop="insertTime" label="时间" :formatter="formatTime"
                             align="center" v-if="scoreType == 1"></el-table-column>
            <el-table-column prop="item" label="积分条目" align="center" v-if="scoreType == 1"></el-table-column>
            <el-table-column prop="score" label="得分" align="center" v-if="scoreType == 1"></el-table-column>
          </el-table>
          <el-pagination class="pagination table-pagination" :current-page="dialogData.tab1.pageNo"
                         @current-change="handleCurrentChange1"
                         :total="dialogData.tab1.total" :page-size="10"
                         layout="total,prev, pager, next, jumper">
          </el-pagination>
        </i>

        <b style="display: block; font-style:normal;padding: 20px 20px 0 20px;background-color: #f4f4f4"
           class="table" v-else>
          <el-table size="small" border style="width: 100%" :data="dialogData.tab2.data">
            <el-table-column type="index" label="编号" align="center"></el-table-column>
            <el-table-column prop="insertTime" label="时间" :formatter="formatTime" align="center"></el-table-column>
            <el-table-column prop="item" label="积分条目" align="center"></el-table-column>
            <el-table-column prop="score" label="得分" align="center"></el-table-column>
          </el-table>
          <el-pagination class="pagination table-pagination" :current-page="dialogData.tab2.pageNo"
                         @current-change="handleCurrentChange2"
                         :total="dialogData.tab2.total" :page-size="10"
                         layout="total,prev, pager, next, jumper">
          </el-pagination>
        </b>
        <div class="Determine pointer" @click="dialogTableVisible=false">确定</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  //韩金辰180725重写，合并三个同级子组件，仅保留这一个
  import moment from 'moment'
  import utils from '../../common/js/util'
  import formRules from '../../common/js/formRules'

  export default {
    props: ["auths", "page", 'scoreType'],
    name: 'scoreDetailed',
    data() {
      return {
        //页面数据
        rules: {idCard: [formRules.idcard]},
        paramForm: {
          idCard: null,
          name: '',
          empPk: null
        },
        //主页table数据
        loading: false,
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        total: null,
        //弹框相关数据
        dialogTableVisible: false,
        load: false,
        dialogTab: 1,//弹窗中的第几页
        dialogData: {
          salesmanId: '',
          name: '',
          tab1: {
            data: [],
            pageNo: 1,
            total: null,
            time: '',
            startTime: '',
            endTime: '',
          },
          tab2: {
            data: [],
            pageNo: 1,
            total: null,
            time: '',
            startTime: '',
            endTime: '',
          }
        },
      }
    },
    mounted() {
      this.getData(true)
    },
    methods: {
      hehe(row){
        console.log(row)
      },
      //工具类，叠加对象的每个属性的分值
      returnScore(obj) {
        let num = 0
        for (let i in obj) {
          num += Number(obj[i])
        }
        return num
      },
      //工具类-时间转换
      formatTime(row, column, cellValue) {
        return moment(cellValue).format('YYYY-MM-DD')
      },
      //主页筛选按钮
      submitForm() {
        this.pageNo = 1
        this.getData(true)
      },
      //获取主页数据
      getData(getCount) {
        this.loading = true
        let params = {
          idCard: this.paramForm.idCard,
          name: this.paramForm.name,
          empPk: this.paramForm.empPk,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          scoreType: this.scoreType
        }
        //查数据
        this.$http({
          method: "get", params,
          url: '/rest/SearchScoreDetails/searchScore'
        }).then(res => {
          res.data.map(item => {
            item.idcard = utils.plusXing(String(item.idcard), 6, 4)
          })
          this.tableData = res.data
          this.loading = false
        }).catch(err => {
          utils.myNotify(this, 'warning', err.response, '查询失败，请稍后重试')
          this.loading = false
        })
        //查条数
        if (getCount) {
          this.$http({
            method: "get", params,
            url: '/rest/SearchScoreDetails/countSearchScore'
          }).then(res => {
            this.total = res.data
          }).catch(err => {
            utils.myNotify(this, 'warning', err.response, '查询失败，请稍后重试')
          })
        }
      },
      //主页table-跳页、调size
      handleSizeChange(value) {
        this.pageSize = value
        this.getData(false)
      },
      handleCurrentChange(value) {
        this.pageNo = value
        this.getData(false)
      },
      //主页-点击查看明细
      showDetails(row) {
        let reset = {
          data: [],
          pageNo: 1,
          total: null,
          time: '',
          startTime: '',
          endTime: '',
        }
        this.dialogData = {
          salesmanId: row.salesmanId,
          name: row.name,
          tab1: JSON.parse(JSON.stringify(reset)),//直接存指针的话，tab1和2会串位
          tab2: JSON.parse(JSON.stringify(reset)),
        }
        if(this.scoreType == 1){
          this.getDetail(true, 0)//0是项目分
        }else{
          this.getDetail(true, 1);//1是星级交互分
          this.getDetail(true, 2);//2信用交互分
        }
      },
      //获取弹窗数据
      getDetail(getTotal, scoreFlag) {
        this.load = true
        let data = this.dialogData
        //目前tab2中没有搜索选项，所以仅在首次进入的时候获取一次数据，其他时间不涉及tab2的搜索
        // 获取tab2时pageNo sTime eTime都是初始值，直接用tab1的即可
        let params = {
          salesmanId: data.salesmanId,
          scoreType: this.scoreType,
          pageNo: data[`tab${scoreFlag==2?2:1}`].pageNo,//积分必是第一页，星级信用根据实际的来
          pageSize: 10,
          startTime: scoreFlag != 2 ? data.tab1.startTime : null,//积分传时间区间，星级信用的第一页传时间区间
          endTime: scoreFlag != 2 ? data.tab1.endTime : null,
          scoreFlg:scoreFlag,//标志位，是查项目分1,还是交互分2,还是全部0
        }
        this.dialogTableVisible = true
        //查数据
        this.$http({
          method: "get",
          url: '/rest/SearchScoreDetails/searchScoreDetails',
          params
        }).then(res => {
          data[`tab${scoreFlag==2?2:1}`].data = res.data.list
          data[`tab${scoreFlag==2?2:1}`].total = res.data.countSize
          this.load = false
        }).catch(err => {
          utils.myNotify(this, 'warning', err.response, '查询失败，请稍后重试')
          this.load = false
        })
        // //查条数
        // if (getTotal) {
        //   this.$http({
        //     method: "get",
        //     url: '/rest/SearchScoreDetails/countSearchScoreDetails',
        //     params
        //   }).then(res => {
        //     data[`tab${scoreFlag==2?2:1}`].total = res.data.count
        //   }).catch(err => {
        //     utils.myNotify(this, 'warning', err.response, '查询失败，请稍后重试')
        //   })
        // }
      },
      //弹窗-tab1跳页
      handleCurrentChange1(value) {
        this.dialogData.tab1.pageNo = value
        this.getDetail(false, this.scoreType == 1 ? 0 : 1)//可能是从积分或者星级和信用的项目页进来的
      },
      //弹窗-tab2的跳页，因为不能附加传参，所以只能写两个方法
      handleCurrentChange2(value){
        this.dialogData.tab2.pageNo = value
        this.getDetail(false, 2)//只能是从星级和信用的交互页进来的
      },
      //弹窗-筛选按钮
      submitForm2() {
        let data = this.dialogData.tab1
        if (data.time[0]) {
          data.startTime = new Date(data.time[0]).getTime()
        }
        if (data.time[1]) {
          data.endTime = new Date(data.time[1]).getTime() + 82800000//？？？？？？
        }
        data.pageNo = 1
        this.getDetail(true, this.scoreType == 1 ? 0 : 1)//可能是从积分或者星级和信用的项目页进来的
      },
    }
  }
</script>
<style scoped lang="scss">
  .mingxi {
    color: #81ba83;
    cursor: pointer;
  }

  //这啥
  .is-in-pagination input {
    width: 30px;
  }

  .tableWrap {
    & > div {
      width: 160px;
      height: 30px;
      display: inline-block;
    }
    & > span {
      margin-left: 40px;
      margin-right: 5px;
      color: #a3a3a3;
    }
  }

  .Determine {
    display: inline-block;
    background-color: #2d2c7a;
    color: white;
    padding: 5px 26px;
    border-radius: 5px;
    margin-left: 47%;
    margin-top: 22px;
  }

  .chooseHeader {
    & > div {
      width: 80px;
      height: 30px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      display: inline-block;
      text-align: center;
      line-height: 30px;
      font-weight: 600;
    }
    .isChoose {
      background-color: #f4f4f4;
      color: #2c2d7d
    }
  }

  b {
    font-weight: normal
  }

  .search {
    margin-bottom: 10px;
    margin-top: -10px;
    padding-left: 10px;
  }

  .hoverWrap {
    position: relative;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .hoverPopKey {
      display: inline-block;
      color: #81bc82;
    }
    .hoverPopValue {
      width: 40px;
      height: 20px;
      background-color: #81bc82;
      color: white;
      border-radius: 5px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/E_scoreDetailed.vue